<app-ice-alert type="info" [iconName]="IconNames.ice_info">
  For å fortsette med MobilBytte-bytte må kunden velge å bruke forsikringen sin. Hvis forsikringen ikke benyttes, må kunden
  selv reparere telefonen før innlevering.
</app-ice-alert>
<p class="insurance-title">Ønsker kunden å bruke forsikringen?</p>
<p>
  Siden mobilen har skader, må den repareres. Kunden trenger bare å sende den inn - ice fikser resten. Kunden betaler kun
  egenandelen på forsikringen.
</p>
<p class="insurance-title">Krav for å fortsette med MobilBytte</p>
<p>
  For å gå videre må kunden bruke forsikringen for å reparere den skadede telefonen.
  <br />
  Hvis forsikringen ikke benyttes eller reparasjon ikke utføres, kan telefonen ikke byttes inn.
</p>
<app-information-button
  [activeLabel]="'Skjul informasjonen'"
  [inactiveLabel]="'Hva er en godkjent reparatør?'"
  (toggleInfo)="toggleWhatIsAnApprovedServicePoint()"
/>
<app-ice-checkbox
  forId="is-customer-using-insurance"
  label="Ja, kunde ønsker å bruke forsikringen og er informert om en egenandel som kommer kommer på en senere faktura."
  ngDefaultControl
  testId="is-customer-using-insurance-input"
  [errorOnTouchedOnly]="true"
  [formControl]="isCustomerUsingInsurance"
/>
